export default __webpack_public_path__ + "static/media/testFantasy.ad937c41.jpg";